import api from './api';

/**
 * Obtener todas las unidades de medida
 */
export const getUnits = async (params = {}) => {
  try {
    console.log('📡 [unitsService] Enviando petición GET a:', '/api/configuration/units');
    console.log('📋 [unitsService] Parámetros:', params);
    
    const response = await api.get('/configuration/units', { params });
    
    console.log('✅ [unitsService] Respuesta recibida exitosamente');
    console.log('📦 [unitsService] Response completo:', response);
    console.log('📊 [unitsService] Response.data:', response.data);
    console.log('🔍 [unitsService] Tipo de response.data:', typeof response.data);
    console.log('📈 [unitsService] response.data.success:', response.data?.success);
    console.log('📋 [unitsService] response.data.data:', response.data?.data);
    console.log('🔢 [unitsService] Cantidad de unidades:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
    
    if (Array.isArray(response.data?.data)) {
      console.log('📝 [unitsService] Primeras 3 unidades:', response.data.data.slice(0, 3));
      console.log('🔑 [unitsService] Estructura de una unidad:', response.data.data[0] ? Object.keys(response.data.data[0]) : 'No hay unidades');
    }
    
    return response.data;
  } catch (error) {
    console.error('❌ [unitsService] Error al obtener unidades de medida:', error);
    console.error('📊 [unitsService] Error.response:', error.response);
    console.error('📋 [unitsService] Error.response?.data:', error.response?.data);
    console.error('🔢 [unitsService] Error.status:', error.response?.status);
    throw error;
  }
};

/**
 * Obtener una unidad de medida por ID
 */
export const getUnit = async (id) => {
  try {
    const response = await api.get(`/configuration/units/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener unidad de medida:', error);
    throw error;
  }
};

/**
 * Crear una nueva unidad de medida
 */
export const createUnit = async (unitData) => {
  try {
    console.log('📡 [unitsService] Enviando petición POST a:', '/api/configuration/units');
    console.log('📤 [unitsService] Datos a enviar:', unitData);
    
    const response = await api.post('/configuration/units', unitData);
    
    console.log('✅ [unitsService] Unidad creada exitosamente');
    console.log('📦 [unitsService] Response completo:', response);
    console.log('📊 [unitsService] Response.data:', response.data);
    console.log('🔍 [unitsService] Unidad creada:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [unitsService] Error al crear unidad de medida:', error);
    console.error('📊 [unitsService] Error.response:', error.response);
    console.error('📋 [unitsService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Actualizar una unidad de medida
 */
export const updateUnit = async (id, unitData) => {
  try {
    console.log('📡 [unitsService] Enviando petición PUT a:', `/api/configuration/units/${id}`);
    console.log('📤 [unitsService] ID de unidad:', id);
    console.log('📤 [unitsService] Datos a enviar:', unitData);
    
    const response = await api.put(`/configuration/units/${id}`, unitData);
    
    console.log('✅ [unitsService] Unidad actualizada exitosamente');
    console.log('📦 [unitsService] Response completo:', response);
    console.log('📊 [unitsService] Response.data:', response.data);
    console.log('🔍 [unitsService] Unidad actualizada:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [unitsService] Error al actualizar unidad de medida:', error);
    console.error('📊 [unitsService] Error.response:', error.response);
    console.error('📋 [unitsService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Eliminar una unidad de medida
 */
export const deleteUnit = async (id) => {
  try {
    const response = await api.delete(`/configuration/units/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar unidad de medida:', error);
    throw error;
  }
};

